import { useRef } from "react";
import { Button, Dropdown, MenuProps } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { ReportType } from "@/reports/types/Api";
import { SafetyValveReport } from "@/reports/types/SafetyValveReport";
import ExportPdfButton, { ExportPdfButtonRef } from "./ExportPdfButton";
import ExportJmdButton, { ExportJmdButtonRef } from "./ExportJmdButton";

interface ExportDropdownButtonProps {
  formValues: SafetyValveReport;
  reportType: ReportType;
}

const ExportDropdownButton = ({
  formValues,
  reportType,
}: ExportDropdownButtonProps) => {
  const exportPdfButtonRef = useRef<ExportPdfButtonRef>(null);
  const exportJmdButtonRef = useRef<ExportJmdButtonRef>(null);

  return (
    <>
      <Dropdown
        menu={{
          items: [
            {
              label: "Export Report (PDF)",
              key: "PDF",
            },
            {
              label: "Export Tag Data (JMD)",
              key: "JMD",
            },
          ] as MenuProps["items"],
          onClick: ({ key }) => {
            if (key === "JMD") {
              exportJmdButtonRef.current?.triggerExport();
            }
            if (key === "PDF") {
              exportPdfButtonRef.current?.triggerExport();
            }
          },
        }}
      >
        <Button icon={<DownOutlined />} type="primary">
          Export
        </Button>
      </Dropdown>
      <ExportPdfButton
        ref={exportPdfButtonRef}
        reportType={reportType}
        displayButton={false}
      />
      <ExportJmdButton
        ref={exportJmdButtonRef}
        displayButton={false}
        formValues={formValues}
      />
    </>
  );
};

export default ExportDropdownButton;
